/**
 * Central kill-switch for outbound documentation links.
 *
 * All product docs still live on entellica.online, which does not match the
 * Entellica branding, so every "Read docs" / "Learn More" affordance is
 * suppressed until an Entellica docs site exists. Flip this to `true` (and set
 * `DOCS_BASE_URL`) to bring the links back.
 */
export const DOCS_LINKS_ENABLED = false;

/**
 * Returns `href` only while docs links are enabled, so callers can pass the
 * result straight into a component that already hides its link when the href
 * is undefined.
 */
export function docsHref(href?: string): string | undefined {
  return DOCS_LINKS_ENABLED ? href : undefined;
}

/**
 * True when an action exists purely to send the user to the docs, so callers
 * can drop the whole affordance (a bare "Learn More" button) rather than
 * render one that navigates nowhere.
 */
export function isSuppressedDocsLink(href?: string): boolean {
  if (DOCS_LINKS_ENABLED || !href) return false;
  return /^https?:\/\/(www\.)?entellica\.com\//.test(href);
}
